import { SET_CUSTOMERS_VIEW } from '../../types';

const setCustomersView = (status, formStatus) => (dispatch) => {
  dispatch({ type: SET_CUSTOMERS_VIEW, status, formStatus });
};

export { setCustomersView };
